// DualButtonCTA.js
import React from "react";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import clsx from "clsx";
import { ButtonVariantTypes, getButtonVariantStylesAndSize } from "components/ui/button";

export type ButtonVariant =
  | "default"
  | "destructive"
  | "outline"
  | "brand"
  | "brand-2"
  | "secondary"
  | "ghost"
  | "linkIconArrow"
  | "link"
  | "linkIcon"
  | "brandLink"
  | "slideUp"
  | "started";

export type ButtonSize =
  | "default"
  | "defaultLink"
  | "smallLink"
  | "sm"
  | "lg"
  | "xl"
  | "xlb"
  | "better"
  | "xxl"
  | "icon";

interface ButtonProps {
  buttonText: string;
  buttonUrl?: string;
  buttonVariant: ButtonVariant;
  buttonSize?: ButtonSize;
  icon?: React.ReactNode; // New icon prop
}

interface DualButtonCTAProps {
  button1?: ButtonProps;
  button2?: ButtonProps;
  isLeftAligned?: boolean;
}

const DualButtonCTA: React.FC<DualButtonCTAProps> = ({ button1, button2, isLeftAligned }) => {
  return (
    <div
      className={`flex w-full flex-col items-center gap-4 @8xl:pb-12 @8xl:pt-6 lg:flex-row ${
        isLeftAligned ? "justify-center lg:justify-start" : "justify-center"
      }`}
    >
      {button1 && (
        <Link href={button1.buttonUrl || ""}>
          <span
            className={clsx(
              getButtonVariantStylesAndSize({
                variant: button1.buttonVariant as ButtonVariantTypes,
                size: button1.buttonSize || "better" // Use buttonSize with "better" as default,
              }),
              "!whitespace-normal py-1 text-center"
            )}
          >
            {button1.buttonText} <ArrowRight size={16} className="ml-2" strokeWidth={1} absoluteStrokeWidth />
          </span>
        </Link>
      )}
      {button2 && (
        <Link href={button2.buttonUrl || ""}>
          <span
            className={clsx(
              getButtonVariantStylesAndSize({
                variant: button2.buttonVariant as ButtonVariantTypes,
                size: button2.buttonSize || "better"
              }),
              "h-auto !whitespace-normal py-1 text-center"
            )}
          >
            {button2.buttonText}
          </span>
        </Link>
      )}
    </div>
  );
};

export default DualButtonCTA;
